import React from 'react'
import styled from 'styled-components'
import { ErrorMessage } from 'formik'

import { media } from '../theme'

const Container = styled.div`
  color: ${p => p.theme.color.copySecondary};
  font-size: ${p => p.theme.fontSize(0.5)};
  line-height: 1;
  margin-bottom: ${p => p.theme.spacing(0)};
  text-transform: uppercase;
  text-align: ${p => p.textAlign || 'left'};

  ${media.greaterThan('medium')`
    margin-top: ${p => p.theme.spacing(-1)};
  `};

  &:empty {
    display: none;
  }
`

const FormErrorMessage = ({ name, ...props }) => (
  <Container {...props}>
    <ErrorMessage name={name} />
  </Container>
)

export default FormErrorMessage



// WEBPACK FOOTER //
// ./src/components/FormErrorMessage.js